import type { SelectedPerson } from '@/db/types/user';

/**
 * Whether the editor shows the floating issue controls instead of the error
 * banner. They roll out behind a Flipper flag for the person or organization
 * (`floating_issue_controls` on the current user's person); a form with soft
 * validations always uses them, since its warnings only show there.
 */
export function usesFloatingIssueControls(
  person: Pick<SelectedPerson, 'floating_issue_controls'> | null | undefined,
  definition: { soft_validations?: Record<string, unknown> } | null | undefined,
): boolean {
  return !!person?.floating_issue_controls || Object.keys(definition?.soft_validations ?? {}).length > 0;
}
